import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Button, FormGroup, Label, Input } from 'reactstrap';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Autocomplete } from '@react-google-maps/api';
import { setActiveFlow, setCurrentStep, setFormData } from 'store/slices/flowSlice';
import { useTranslation } from "react-i18next";


const DomesticForm = ({ onNext }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const fromCityZipRef = useRef(null);
  const toCityZipRef = useRef(null);



  // Updated validation schema since we no longer need city/zipcode
  const SignupSchema = Yup.object().shape({
    toAddress: Yup.string().required(t('Required')),
    fromAddress: Yup.string().required(t('Required')),
  });

  // Modified handlePlaceSelect to capture full address
  const handlePlaceSelect = (autocomplete, setFieldValue, field) => {
    if (autocomplete) {
      const place = autocomplete.getPlace();

      if (place && place.formatted_address) {
        sessionStorage.setItem(field, place.formatted_address);
        setFieldValue(field, place.formatted_address);
      } else {
        alert(t('Unable to retrieve a valid address. Please try selecting again.'));
      }
    } else {
      alert(t('Autocomplete is not initialized properly.'));
    }
  };

  return (
    <Formik
      initialValues={{
        fromLocation: null,
        fromAddress: '',
        toLocation: null,
        toAddress: '',
        deliveredToRecipient: false,
        pickupRequired: false
      }}
      validationSchema={SignupSchema}
      onSubmit={(values) => {
        dispatch(setFormData(values));
        dispatch(setActiveFlow('domestic'));
        dispatch(setCurrentStep('1'));
        onNext();
      }}
    >
      {({ setFieldValue, errors, touched, values }) => (
        <Form>
          <Row>
            <Col sm="12">
              <FormGroup className="e2g-cargo-form-group">
                <Label className="e2g-cargo-form-label mb-2 fs-custom fw-bold text-dark e2g-form-size form-label" for="fromAddress">
                  {t("From")}
                </Label>
                <Autocomplete
                  className="rounded border-0 e2g-form-input"
                  onLoad={(autocomplete) => (fromCityZipRef.current = autocomplete)}
                  onPlaceChanged={() =>
                    handlePlaceSelect(fromCityZipRef.current, setFieldValue, 'fromAddress')
                  }
                  options={{
                    types: ['address'], // Restrict to address results
                    componentRestrictions: {
                      country: 'IE',
                    },
                  }}
                >
                  <Field
                    className="border-0 text-dark custom-input-field"
                    name="fromAddress"
                    as={Input}
                    placeholder={t('Provide Full Address')}
                  />
                </Autocomplete>
                {errors.fromAddress && touched.fromAddress ? (
                  <div className="e2g-error-text text-danger">{errors.fromAddress}</div>
                ) : null}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <FormGroup className="e2g-cargo-form-group">
                <Label className="e2g-cargo-form-label mb-2 fs-custom fw-bold text-dark e2g-form-size form-label" for="toAddress">
                  {t("To")}
                </Label>
                <Autocomplete
                  className="rounded border-0 e2g-form-input"
                  onLoad={(autocomplete) => (toCityZipRef.current = autocomplete)}
                  onPlaceChanged={() =>
                    handlePlaceSelect(toCityZipRef.current, setFieldValue, 'toAddress')
                  }
                  options={{
                    types: ['address'], // Restrict to address results
                    componentRestrictions: {
                      country: 'IE',
                    },
                  }}
                >
                  <Field
                    className="border-0 text-dark custom-input-field"
                    name="toAddress"
                    as={Input}
                    placeholder={t('Provide Full Address')}
                  />
                </Autocomplete>
                {errors.toAddress && touched.toAddress ? (
                  <div className="e2g-error-text text-danger">{errors.toAddress}</div>
                ) : null}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm="12" className="text-left e2g-form-btn">
              <Button
                type="submit"
                color="dark"
                className="btn btn-dark rounded-pill e2g-land-btn text-capitalize fw-medium"
              >
                {t("Get a spot offer")}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default DomesticForm;
